
<div class="container container-slim">
  <div class="text-center">
    <h2 class="headline">Vielen Dank für die Registrierung!</h2>
    <h2 class="headline">Thank you for registering!</h2>
  </div>
  <div class="row text-center">
    <div class="col-sm-12">
      Vielen Dank! Wir haben gerade eine E-Mail an {{email}} geschickt. Bitte klicke auf den Link in der E-Mail, um die Registrierung abzuschließen. <br/> Thank you! We just sent an e-mail to {{email}}. Please follow the link in this mail in order to complete your registration process.
    </div>
  </div>
  <div class="row text-center">
    <div class="col-sm-6 hidden-xs">
      <a class="badge__image" href='https://itunes.apple.com/de/app/leada/id1063816865'>
        <img class="badge__image-apple--small" alt='Download on the App Store' src='assets/apple-app_store-badge.svg'/>
      </a>
    </div>
    <div class="col-sm-6 visible-xs">
      <a class="badge__image" href='https://itunes.apple.com/de/app/leada/id1063816865'>
        <img class="badge__image-apple" alt='Download on the App Store' src='assets/apple-app_store-badge.svg'/>
      </a>
    </div>
    <div class="col-sm-6">
      <a class="badge__image" href='https://play.google.com/store/apps/details?id=de.leada.app'>
        <img class="badge__image" alt='Get it on Google Play' src='assets/google-play-badge.png'/>
      </a>
    </div>
  </div>
  <div class="row text-center">
    <div class="col-sm-12">
      <p class="text-center">Alternativ können sie Leada auch online im Browser nutzen:</p>
      <p class="text-center">Alternatively, you can also use Leada online in your browser:</p>
      <p class="text-center"><a href="https://app.leada.de/">app.leada.de</a></p>
    </div>
  </div>
</div>
